<template>
    <form @submit.prevent="$emit('submit', userForm)">
        <header>
            <h3>{{ title }}</h3>
        </header>
        <p class="msg--error" v-if="error.email">{{ error.email }}</p>
        <custom-input :label="$t('email')" type="email" required v-model="userForm.email"></custom-input>
        <custom-input :label="$t('password')" type="password" required v-model="userForm.password" v-if="!title.includes('Edit')"></custom-input>

        <div class="flex-row control">
            <button class="button--cancel" type="reset" @click.prevent="$emit('cancel')">{{ $t('cancel') }}</button>
            <button class="button--ok" type="submit">{{ submitText }}</button>
        </div>
    </form>
</template>

<script>
import CustomInput from '@/components/utils/CustomInput.vue'
// import CustomRadio from '@/components/utils/CustomRadio.vue'
export default {
	props: {
		error: {
			type: Object,
			default: () => {}
		},

		title: {
			type: String,
			default: 'Input Details'
		},

		submitText: {
			type: String,
			default: 'Ok'
		},

		value: {
			type: Object,
			default: () => {}
		},

		loading: {
			type: Boolean,
			default: false
		}
	},

	watch: {
		value: {
			handler (val) {
				if (!val) return
				this.userForm.email = val.email || ''
				this.userForm.password = val.password || ''
			},

			immediate: true
		},

		error (val) {
			if (val) {
				const el = this.$el.parentElement.parentElement
				if (el) el.scrollTo(0, 0)
			}
		}
	},

	data () {
		return {
			userForm: {
				email: '',
				password: ''
			}
		}
	},

	beforeDestroy () {
		this.$emit('close')
	},

	components: {
		CustomInput
	}
}
</script>
